import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { COMMON_IMPORTS } from "@app/common-imports"
import { PolicyFormFillComponent } from "@app/policy-form-fill/policy-form-fill.component"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { LogoutTimerService } from "@app/services/logout-timer.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-person-policy-form-fill",
	imports: [
		COMMON_IMPORTS,
		BtnExtComponent,
		LangValPipe,
		PolicyFormFillComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="patient-fill">
			@if (isLoggedOut) {
				<div>{{ "error" | langVal }}</div>
			} @else {
				@if (hasLoaded) {
					@if (!isDone) {
						@if (res?.user_name) {
							<p>{{ "you_are_invited_by" | langVal }} {{ res.user_name }}</p>
						}
						@if (res?.filled) {
							<p>{{ "error" | langVal }}</p>
						}
					}
					@if (isDone) {
						<div>
							<p>
								{{ res.name }} , {{ "thank_you_for_filling_form" | langVal }}
							</p>
							@if (id) {
								<app-btn-ext
									text="download"
									(clickEv)="download()"
									iconName="download"
								/>
							}
						</div>
					} @else {
						@if (version_id) {
							<app-policy-form-fill
								(onFinish)="handleFinish($event)"
								(onSaveState)="handleSaveState($event)"
								[version_id]="version_id"
								[state]="$safeNavigationMigration(res?.state)"
								isNested
							/>
						}
					}
				}
			}
		</div>
	`,
})
export class PersonPolicyFormFillComponent implements OnInit {
	siteData: any = []
	hasLoaded: boolean = false
	res: any = null
	version_id: number = 0
	isDone: boolean = false
	isLoggedOut: boolean = false
	id: number = 0

	@Input() code: string = ""

	constructor(
		private apiService: ApiService,
		protected route: ActivatedRoute,
		public modalService: ModalService,
		public lang: LangService,
		private store: StoreService,
		private logoutTimerService: LogoutTimerService
	) {}

	async ngOnInit() {
		await this.store.timeout(500)
		this.init()
	}
	async init() {
		const res = await this.apiService.post("policy_form_init", {
			code: this.code,
		})
		this.hasLoaded = true
		if (!res) {
			return
		}
		this.res = res
		if (res?.filled) {
			return
		}
		this.version_id = res.policy_form_versions?.[0]?.id
		this.siteData = {
			policy_forms: res.policy_forms,
			policy_form_versions: res.policy_form_versions,
			policy_form_version_fields: res.policy_form_version_fields,
		}

		sessionStorage.setItem("siteData", JSON.stringify(this.siteData))

		this.logoutTimerService.init(15, () => {
			this.isLoggedOut = true
			sessionStorage.removeItem("siteData")
		})

		if (!this.version_id) {
			console.log(1)
			return
		}
	}
	async handleSaveState(version: any) {
		const fields = version.fields
			.filter((it) => it.field_type !== "remark")
			.map((item) => ({
				id: item.id,
				answer: item.answer,
			}))

		await this.apiService.post("policy_form_save_state", {
			fields,
			code: this.code,
		})
	}

	async handleFinish(version: any) {
		if (!version) {
			return
		}
		this.isDone = true

		const { id } = await this.apiService.post("person_answer_policy_form", {
			...version,
			code: this.code,
		})
		this.id = id
		this.modalService.openToast("saved_successfully")
	}
	download() {
		this.store.downloadToastFunc(async () => {
			const resPdf: any = await this.apiService.download(
				"person_download_policy_form",
				{ id: this.id, code: this.code }
			)
			if (!resPdf?.size) {
				return this.modalService.openToast("save_failed")
			}
			this.apiService.downloadFile(
				resPdf,
				this.lang.getVal("policy_form") + ".pdf"
			)
		})
	}
}
